module.exports = __webpack_public_path__ + "static/media/theme-modern.e36a671b.png";